import { UPDATE_MAP_CENTER } from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_MAP_CENTER:
      // Return same reference if values haven't changed to prevent
      // unnecessary GoogleMapReact re-centering (which causes map flash)
      if (state.lat === payload.lat && state.lng === payload.lng) {
        return state;
      }
      return { ...state, ...payload };
    default:
      return state;
  }
}
